<template>
  <div class="wrapper-container" :style="{ backgroundColor, padding: `${padding}px` }">
    <slot name="content" />
  </div>
</template>

<style lang="scss" scoped>
.wrapper-container {
  border: 1px solid #d6dbde;
  border-radius: 6px;
}
</style>

<script>
export default {
  name: "Wrapper",
  props: {
    backgroundColor: {
      type: String,
      default: "#fff",
    },
    padding: {
      type: [Number, String],
      default: 30,
    },
  },
};
</script>
